import c from 'classnames';

import { Icon } from '@repo/ui';
import { useScrollDisplay } from '../../hooks/useScrollDisplay';
import { TINYAI_CONSTANTS } from './constants';

import styles from './TinyAIFloatingButton.module.css';

interface TinyAIFloatingButtonProps {
  onClick: () => void;
  scrollableElRef?: React.RefObject<HTMLElement>;
}

export const TinyAIFloatingButton = ({
  onClick,
  scrollableElRef,
}: TinyAIFloatingButtonProps) => {
  const isAtTop = useScrollDisplay({
    threshold: TINYAI_CONSTANTS.SCROLL_THRESHOLD,
    action: 'hide',
    scrollableElRef,
  });

  return (
    <button
      className={c(styles.floatingButton, {
        [styles.shrunk]: !isAtTop,
      })}
      onClick={onClick}
      aria-label='Ask TinyAI'
    >
      <Icon name='aiStarsFilled' />
      <span className={styles.label}>Ask TinyAI</span>
    </button>
  );
};
